import { Component, OnInit, ElementRef } from '@angular/core';
import { Helpers } from "../../helpers";

@Component({
  selector: 'gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.less']
})
export class GalleryComponent implements OnInit {
  galleries: any = [
    {
      title: "Guild Ball Alchemists",
      titleImage: "/assets/img/gallery/guild_ball_alchemist/alchemists_gruppenfoto.jpg",
      images: [
        "/assets/img/gallery/guild_ball_alchemist/Calculus.jpg",
        "/assets/img/gallery/guild_ball_alchemist/Mercury.jpg",
        "/assets/img/gallery/guild_ball_alchemist/Midas.jpg",
        "/assets/img/gallery/guild_ball_alchemist/Venin.jpg",
        "/assets/img/gallery/guild_ball_alchemist/compound.JPG",
        "/assets/img/gallery/guild_ball_alchemist/katalyst.jpg"
      ]
    },
    {
      title: "Warhammer Death Guard",
      titleImage: "/assets/img/gallery/death_guard/nurgle_gruppenfoto.jpg",
      images: [
        "/assets/img/gallery/death_guard/typhus.JPG",
        "/assets/img/gallery/death_guard/caster.JPG",
        "/assets/img/gallery/death_guard/lordofcontagion.JPG",
        "/assets/img/gallery/death_guard/marines_1.JPG",
        "/assets/img/gallery/death_guard/marines_2.JPG",
        "/assets/img/gallery/death_guard/marines_3.JPG",
        "/assets/img/gallery/death_guard/poxwalkers_1.JPG",
        "/assets/img/gallery/death_guard/poxwalkers_2.JPG",
        "/assets/img/gallery/death_guard/foetid_bloat_drone.jpg"
      ]
    },
    {
      title: "Malifaux Resurrectionists",
      titleImage: "/assets/img/gallery/mcmourning_crew/mcmourning_gruppenfoto.jpg",
      images: [
        "/assets/img/gallery/mcmourning_crew/dog.jpg",
        "/assets/img/gallery/mcmourning_crew/fleshconstruct.jpg",
        "/assets/img/gallery/mcmourning_crew/mcmourning.jpg",
        "/assets/img/gallery/mcmourning_crew/nurse1.jpg",
        "/assets/img/gallery/mcmourning_crew/nurse2.jpg",
        "/assets/img/gallery/mcmourning_crew/sebastian.jpg",
      ]
    },
    {
      title: "Malifaux Gremlins",
      titleImage: "/assets/img/gallery/gremlins/gremlins_gruppenfoto.jpg",
      images: [
        "/assets/img/gallery/gremlins/gracie.jpg",
        "/assets/img/gallery/gremlins/gremlins1.jpg",
        "/assets/img/gallery/gremlins/gremlins2.jpg",
        "/assets/img/gallery/gremlins/gremlins3.jpg",
        "/assets/img/gallery/gremlins/warpig.jpg"
      ]
    }
  ]
  constructor() { }

  private openGallery(gallery: ElementRef) {
    Helpers.addClass(gallery, 'show');
  }
  private closeGallery(gallery: ElementRef, e: any) {
    if (Helpers.hasClass(e.target, 'show')) {
      Helpers.removeClass(gallery, 'show');
      e.stopPropagation()
    }
  }

  public getGalleryBG(index: number): string {
    return 'background-image: url('+this.galleries[index].images[0]+');';
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/gallery/gallery.component.ts